var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataCollSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 30H0V0H30V30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.75C3.75 2.71289 2.91211 1.875 1.875 1.875C0.837891 1.875 0 2.71289 0 3.75V23.4375C0 26.0273 2.09766 28.125 4.6875 28.125H28.125C29.1621 28.125 30 27.2871 30 26.25C30 25.2129 29.1621 24.375 28.125 24.375H4.6875C4.17188 24.375 3.75 23.9531 3.75 23.4375V3.75ZM27.5742 8.82422C28.3066 8.0918 28.3066 6.90234 27.5742 6.16992C26.8418 5.4375 25.6523 5.4375 24.9199 6.16992L18.75 12.3457L15.3867 8.98242C14.6543 8.25 13.4648 8.25 12.7324 8.98242L6.16992 15.5449C5.4375 16.2773 5.4375 17.4668 6.16992 18.1992C6.90234 18.9316 8.0918 18.9316 8.82422 18.1992L14.0625 12.9668L17.4258 16.3301C18.1582 17.0625 19.3477 17.0625 20.0801 16.3301L27.5801 8.83008L27.5742 8.82422Z",
    fill: "#9333EA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCollSvg);
export default __webpack_public_path__ + "static/media/DataCollSvg.3086856e62135b5923e9b2a8f9461a97.svg";
export { ForwardRef as ReactComponent };